import { createContext, useContext } from 'react';
const defaultConfiguration = {
  LinkComponent: 'a'
};
export const ReaxlConfigurationContext = /* #__PURE__*/createContext(defaultConfiguration);
export const useReaxlConfiguration = () => useContext(ReaxlConfigurationContext);